import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/Price.css'
import xm1 from '../assets/images/space.png'
import {Helmet}from"react-helmet";

import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'

const CheckDot = () => (
  <span className="dot" aria-hidden="true">
    <svg viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="10" cy="10" r="2.25" fill="currentColor" />
    </svg>
  </span>
);

const StarIcon = () => (
  <span className="bd__star" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3.5l2.7 5.47 6.03.88-4.36 4.25 1.03 6.01L12 17.8 6.6 20.16l1.03-6.01-4.36-4.25 6.03-.88L12 3.5z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const ChevronIcon = ({ open }) => (
  <span className={`bd__chev ${open ? "is-open" : ""}`} aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M7 10l5 5 5-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

/* ✅ Premier Private Offices icons */
const CrownIcon = () => (
  <span className="ppo__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M4 8l4 4 4-7 4 7 4-4v10H4V8z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const ArrowIcon = () => (
  <span className="ppo__arrow" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M10 7l5 5-5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

/* ✅ Need Space icons */
const IconDayOffice = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8 21V5a2 2 0 0 1 2-2h8v18"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M6 21h14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M11 9h4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const IconMeeting = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 14c1.7 0 3-1.3 3-3S8.7 8 7 8s-3 1.3-3 3 1.3 3 3 3z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M17 13c1.4 0 2.5-1.1 2.5-2.5S18.4 8 17 8s-2.5 1.1-2.5 2.5S15.6 13 17 13z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M3.5 20c.3-2.7 2.6-4.5 5.5-4.5S14.2 17.3 14.5 20"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.7 20c.2-2 2-3.4 4.3-3.4 2.1 0 3.7 1.2 4 3.4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const IconBoardroom = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 7h12v9H6V7z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M4 17h16"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M9 20v-3M15 20v-3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* ✅ Optional Add-Ons icons */
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M12 7v5l3 2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 7h16v10H4V7z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M4 8l8 6 8-6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ✅ CTA + WHY icons (NEW) */
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const IconBolt = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M13 2L3 14h8l-1 8 11-14h-8l0-6z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const IconMouse = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2c4 0 7 3 7 7v6c0 4-3 7-7 7s-7-3-7-7V9c0-4 3-7 7-7z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M12 6v4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const IconChart = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 19V5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M4 19h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path
      d="M7 14l3-3 3 2 4-5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconBuilding = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 21V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v17"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M5 21h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path
      d="M10 7h1M10 10h1M10 13h1M13 7h1M13 10h1M13 13h1"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const Benefit = ({ icon, label }) => (
  <div className="why__item">
    <div className="why__icon">{icon}</div>
    <div className="why__label">{label}</div>
  </div>
);


const Price = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    AOS.init();
  }, []);

  const breakdownItems = [
    { title: "Executive Presence", sub: "$219/month — Best for address" },
    { title: "Flex Professional", sub: "$499/month — Hybrid access" },
    { title: "Resident", sub: "$649/month — Daily use" },
  ];
  const plans = [
  {
    title: "Executive Presence",
    sub: "$219/month — Best for address",
    includedLeft: [
      "3050 Post Oak Blvd mailing address",
      "Dedicated local phone number",
      "5 hours/month meeting room access",
      "Company name in lobby directory",
    ],
    includedRight: [
      "Mail receipt, sorting & forwarding",
      "Live receptionist — call answering",
      "Access to business lounge during office hours",
      "Package acceptance & notification",
    ],
    overage: [
      "Additional meeting hours: $50/hr",
      "Additional phone time: $25/hr",
      "Mail forwarding (domestic): $25/mo",
    ],
  },
  {
    title: "Flex Professional",
    sub: "$499/month — Hybrid access",
    includedLeft: [
      "Everything in Executive Presence",
      "10 days/month office access",
      "10 hours/month meeting room access",
      "High-speed Wi-Fi & wired internet",
    ],
    includedRight: [
      "Dedicated business phone line",
      "Print, scan, copy access",
      "Kitchen & lounge access",
      "Discounted guest day passes",
    ],
    overage: [
      "Additional day office: $75/day",
      "Additional meeting hours: $45/hr",
      "Guest day pass: $25/person",
    ],
  },
  {
    title: "Resident",
    sub: "$649/month — Daily use",
    includedLeft: [
      "Everything in Flex Professional",
      "Unlimited office access",
      "20 hours/month meeting room access",
      "Dedicated desk space",
    ],
    includedRight: [
      "24/7 building access",
      "Priority meeting room booking",
      "IT support & network access",
      "Discounted private office upgrade path",
    ],
    overage: [
      "Additional meeting hours: $40/hr",
      "Dayroom access: $75/hr",
      "Guest day pass: $15/person",
    ],
  },
];

  return (
    <div>

          <Helmet>
      
      <title>Pricing Plans for Xceed Office CRM | Affordable Plans & Free Trial</title>
      <meta name="description" content="Compare Xceed Office CRM pricing plans for professionals and teams. Explore features, scalable plans, and start with a free trial today."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
      {/* 🔶 HERO SECTION */}
      <section className="p_main">
        <div className="p_main_sec">
          <h1>
            <span style={{ color: "#EEBD2B" }}>            Executive Memberships
</span>
            <br /> 
& Private Offices
          </h1>

          <p>            Flexible workspace solutions designed for professionals who
            value credibility and structure.
 </p>

          <button>
                    <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a>    </button>{" "}
          <button style={{ background: "#0D0D0D", color: "#EEBD2B", opacity: 1 }}>
            Speak With Our Team
          </button>
        </div>
      </section>


      {/* 🔶 PRICING CARDS SECTION */}
      <section   className="pricing-section">
        <div className="cards">

          <article className="card">
            <div className="card__meta">BEST FOR ADDRESS</div>
            <div className="card__name">Executive Presence</div>
            <div className="price">
              <span className="price__amount">$219</span>
              <span className="price__per">/month</span>
            </div>
            <ul className="features">
              <li className="features__item"><CheckDot />Prestigious business address</li>
              <li className="features__item"><CheckDot />Mail handling & forwarding</li>
              <li className="features__item"><CheckDot />Live receptionist service</li>
              <li className="features__item"><CheckDot />5 hours meeting room/month</li>
              <li className="features__item"><CheckDot />Business phone number</li>
              <li className="features__item"><CheckDot />Listed company directory</li>
            </ul>
            <button className="btn btn--ghost">View Details →</button>
          </article>

          <article className="card card--popular">
            <div className="popular-pill">MOST POPULAR</div>
            <div className="card__meta">HYBRID ACCESS</div>
            <div className="card__name">Flex Professional</div>
            <div className="price">
              <span className="price__amount">$499</span>
              <span className="price__per">/month</span>
            </div>
            <ul className="features">
              <li className="features__item"><CheckDot />Everything in Executive Presence</li>
              <li className="features__item"><CheckDot />10 days/month office access</li>
              <li className="features__item"><CheckDot />10 hours meeting room/month</li>
              <li className="features__item"><CheckDot />Dedicated phone line</li>
              <li className="features__item"><CheckDot />Printing & scanning access</li>
              <li className="features__item"><CheckDot />Kitchen & lounge access</li>
            </ul>
            <button className="btn btn--solid">View Details →</button>
          </article>

          <article className="card">
            <div className="card__meta">DAILY USE</div>
            <div className="card__name">Resident</div>
            <div className="price">
              <span className="price__amount">$649</span>
              <span className="price__per">/month</span>
            </div>
            <ul className="features">
              <li className="features__item"><CheckDot />Everything in Flex Professional</li>
              <li className="features__item"><CheckDot />Unlimited office access</li>
              <li className="features__item"><CheckDot />20 hours meeting room/month</li>
              <li className="features__item"><CheckDot />Dedicated desk space</li>
              <li className="features__item"><CheckDot />24/7 building access</li>
              <li className="features__item"><CheckDot />Priority booking</li>
            </ul>
            <button className="btn btn--ghost">View Details →</button>
          </article>

        </div>
      </section>

      {/* ✅ MEMBERSHIP BREAKDOWN */}
 
<section style={{ background: "#171717ff" }} className="breakdown-section">
  <div className="breakdown-header">
    <div className="eyebrow">
      <span className="eyebrow__line" />
      <span className="eyebrow__text">FULL DETAILS</span>
      <span className="eyebrow__line" />
    </div>

    <h2 className="breakdown-title">
      Membership <span>Breakdown</span>
    </h2>
  </div>

  <div className="breakdown-wrap">
    {plans.map((plan, idx) => {
      const open = openIndex === idx;

      return (
    
    <div key={plan.title} className={`bd__item ${open ? "is-open" : ""}`}>
          <button
            className="bd__btn"
            type="button"
            onClick={() => setOpenIndex(open ? null : idx)}
            aria-expanded={open}
          >
            <div className="bd__left">
              <StarIcon />
              <div className="bd__text">
                <div className="bd__title">{plan.title}</div>
                <div className="bd__sub">{plan.sub}</div>
              </div>
            </div>

            <ChevronIcon open={open} />
          </button>

          {/* ✅ DROPDOWN CONTENT */}
          <div
            className="bd__panel"
            style={{ maxHeight: open ? 520 : 0 }}
          >
            <div className="bd__inner">
              <div className="bdBlock">
                <p className="bdBlock__label">INCLUDED FEATURES</p>

                <div className="bdCols">
                  <ul className="bdList">
                    {plan.includedLeft.map((t) => (
                      <li key={t}>
                        <span className="bdDot">•</span>
                        {t}
                      </li>
                    ))}
                  </ul>

                  <ul className="bdList">
                    {plan.includedRight.map((t) => (
                      <li key={t}>
                        <span className="bdDot">•</span>
                        {t}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="bdBlock bdBlock--rates">
                <p className="bdBlock__label">OVERAGE RATES</p>

                <ul className="bdRates">
                  {plan.overage.map((t) => (
                    <li key={t}>
                      <span className="bdDash">—</span>
                      {t}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      );
    })}

  </div>
</section>
 
      {/* ✅ PREMIER PRIVATE OFFICES */}
      <section  className="ppo">
        <div className="ppo__wrap">
          <div className="ppo__eyebrow">
            <span className="ppo__rule" />
            <span className="ppo__eyebrowText">
              <CrownIcon />
              PREMIER TIER
              <CrownIcon />
            </span>
            <span className="ppo__rule" />
          </div>

          <h2 className="ppo__title">
            Premier <span>Private Offices</span>
          </h2>

          <p className="ppo__sub">
            Fully furnished, move-in ready executive suites with all services included.
          </p>

          <p className="ppo__starting">
            Starting at <span>$1,750/month</span>
          </p>

          <div className="ppo__cards">
            <article className="ppoCard">
              <h3 className="ppoCard__title">1–2 Person Suite</h3>
              <div className="ppoCard__price">$1,750 – $2,200</div>
              <p className="ppoCard__desc">Ideal for solo practitioners and small teams</p>
            </article>

            <article className="ppoCard">
              <h3 className="ppoCard__title">3–5 Person Suite</h3>
              <div className="ppoCard__price">$2,800 – $4,500</div>
              <p className="ppoCard__desc">Perfect for growing practices and advisory teams</p>
            </article>

            <article className="ppoCard">
              <h3 className="ppoCard__title">6+ Person Suite</h3>
              <div className="ppoCard__price ppoCard__price--accent">Custom Pricing</div>
              <p className="ppoCard__desc">Tailored for established firms requiring dedicated space</p>
            </article>
          </div>
             <a href="https://calendly.com/xceedoffice-info/new-meeting">
          <button className="ppo__cta" type="button">
            <span className="ppo__ctaIcon" aria-hidden="true">♛</span>
            Schedule a Private Tour
            <ArrowIcon />
          </button>
          </a>
        </div>
      </section>

      {/* ✅ NEED SPACE WITHOUT MEMBERSHIP */}
      <section style={{background:"#171717ff"}}className="needSpace">
        <div className="needSpace__wrap">
          <h2 className="needSpace__title">
            Need Space <span>Without Membership?</span>
          </h2>
          <p className="needSpace__sub">On-demand access to professional workspaces</p>

          <div className="needSpace__cards">
            <article className="nsCard">
              <div className="nsCard__icon"><IconDayOffice /></div>
              <h3 className="nsCard__title">Day Office</h3>
              <div className="nsCard__price">$75/day</div>
              <p className="nsCard__note">Private office for a full business day</p>
            </article>

            <article className="nsCard">
              <div className="nsCard__icon"><IconMeeting /></div>
              <h3 className="nsCard__title">Meeting Room</h3>
              <div className="nsCard__price">$50/hour</div>
              <p className="nsCard__note">4–8 person conference room with AV</p>
            </article>

            <article className="nsCard">
              <div className="nsCard__icon"><IconBoardroom /></div>
              <h3 className="nsCard__title">Boardroom</h3>
              <div className="nsCard__price">$85/hour</div>
              <p className="nsCard__note">Executive boardroom for 10–16 guests</p>
            </article>
          </div>
        </div>
      </section>

      {/* ✅ OPTIONAL ADD-ONS */}
      <section  className="addons">
        <div className="addons__wrap">
          <h2 className="addons__title">
            Optional <span>Add-Ons</span>
          </h2>

          <div className="addons__row">
            <article className="aoCard">
              <div className="aoCard__icon"><IconClock /></div>
              <div className="aoCard__text">
                <div className="aoCard__title">Extra Meeting Hours</div>
                <div className="aoCard__price">From $40/hr</div>
              </div>
            </article>

            <article className="aoCard">
              <div className="aoCard__icon"><IconPhone /></div>
              <div className="aoCard__text">
                <div className="aoCard__title">Extra Phone Line</div>
                <div className="aoCard__price">$35/mo</div>
              </div>
            </article>

            <article className="aoCard">
              <div className="aoCard__icon"><IconMail /></div>
              <div className="aoCard__text">
                <div className="aoCard__title">Mail Forwarding</div>
                <div className="aoCard__price">$25/mo</div>
              </div>
            </article>
          </div>
        </div>
      </section>
      {/* ✅ WHY SECTION (ADDED) */}
      <section style={{background:"#171717ff"}}className="why">
        <div className="why__wrap">
          <h3 className="why__title">
            Why Professionals Choose <span>Xceed</span>
          </h3>

          <div className="why__grid">
            <Benefit icon={<IconBolt />} label="No buildout cost" />
            <Benefit icon={<IconMouse />} label="No infrastructure investment" />
            <Benefit icon={<IconChart />} label="Flexible terms" />
            <Benefit icon={<IconBuilding />} label="Class A address" />
          </div>
        </div>
      </section>


      {/* ✅ CTA SECTION (ADDED) */}
      <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
                            <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a> <span className="cta__arrow">→</span>
            </button>

            <a href="tel:346-502-2552">
            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
            </a>
          </div>

        </div>
      </section>


    </div>
  )
}

export default Price